/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react"
import addCSSClass from "src/libs/layout-app/utils/addCSSClass"
import removeCSSClass from "src/libs/layout-app/utils/removeCSSClass"
import { getCssDemention } from "src/libs/utilities"
import { ALIGN, ContactFormContent, ILandingSection } from "src/modules/pe-landing-module/data/interfaces"
import DataContentEditor from "../landing-edit/editors/data-content-editor"
import { ContactFormPrimitive } from "../primitive"
import Dummy from "./Dummy"
import useLandingSize from "src/modules/pe-landing-module/hooks/useLandingSize"
import { WINDOW_WIDTH } from "src/libs/interfaces/layouts"

/* Protopia Ecosystem component */
export interface IPEWidgetProps {
    section: ILandingSection
    data: ContactFormContent 
}
const ContactForm = ({data, ...props}: IPEWidgetProps): JSX.Element => {
    const sizes           = useLandingSize()
    const [marginLeft]    = useState<string>(!![ALIGN.END, ALIGN.MIDDLE ].find(e => e === data.horizontal_align)  || !data.horizontal_align ? "auto" : "0")
    const [marginRight]   = useState<string>(!![ALIGN.START, ALIGN.MIDDLE ].find(e => e === data.horizontal_align) || !data.horizontal_align ? "auto" : "0")
    const [marginTop]     = useState<string>(!![ALIGN.END, ALIGN.MIDDLE ].find(e => e === data.vertical_align) || !data.vertical_align ? "auto" : "0")
    const [marginBottom]  = useState<string>(!![ALIGN.START, ALIGN.MIDDLE ].find(e => e === data.vertical_align) || !data.vertical_align ? "auto" : "0")
    const [width]         = useState<string>(getCssDemention( data.width, "100%" ))
    const [height, ]      = useState<string>(getCssDemention( data.height, "auto" )) 

    useEffect(() => {
        addCSSClass(
            `landing-cf-${props.section.id}`,
            `.landing-cf-${props.section.id} {
                margin-left: ${marginLeft};
                margin-right: ${marginRight};
                margin-top: ${marginTop};
                margin-bottom: ${marginBottom};
                max-width: ${ width };
                max-height: ${ height };
                width: ${ width };
                height: ${ height };
                z-index: 1;
                .layout-label-vert {
                    padding: 20px!important;
                }
                .pe-cf-title-container { 
                    ${data.font_size ? `font-size: ${getCssDemention(data.font_size * 1.3)};` : ""  }
                }
                .landing-cf-primitive {
                    color: ${ data.text_color };
                    text-align: ${ data.text_align };
                    ${ data.font_size ? `font-size: ${ getCssDemention( data.font_size ) };` : ""  }
                    ${ data.font ? `font-family: ${data.font};` : '' }
                }
            } 
            `
        )           
        return () => {
            removeCSSClass(`landing-cf-${props.section.id}`)
        }
    },[ ]) 
    
    return <div className='pe-cf-container landing-content-container' data-type={data.type} data-content-id={data.id}>
        {
            !!data.fields && !!Object.keys(data.fields)?.length // && sizes.width > WINDOW_WIDTH.MOBILE
                ?
                <div 
                    className={`landing-cf cf-container landing-cf-${props.section.id} ${ data.className || "" } `} 
                    style={ data.style || {} }
                >
                    {
                        !!data.thumbnail && <div 
                            className="cs-thumbnail"
                            style={{backgroundImage:`url(${data.thumbnail})`}} 
                        > 
                        
                        </div>
                    }
                    <div className="w-100">
                        <ContactFormPrimitive 
                            primitive={ {
                                ...(data ),
                            } as any }
                        />
                    </div>
                </div>
                :
                <Dummy {...{ 
                    data: {...data, className: `landing-cf-${props.section.id}`}, 
                    ...props 
                }} />
        } 
        <DataContentEditor data={data}  section={props.section} />       
    </div>
}
export default ContactForm